import React from 'react';

// The underlined text button used throughout the handoff: "Remove", "View all",
// "Deregister", "Cancel plan", "About Subscription", "Undo", cross-links in auth.
type Tone = 'label' | 'ink' | 'secondary' | 'alert' | 'muted';

const TONES: Record<Tone, string> = {
    label: 'text-label',
    ink: 'text-ink',
    secondary: 'text-ink-secondary',
    alert: 'text-alert',
    muted: 'text-muted',
};

type Props = {
    tone?: Tone;
    className?: string;
    children: React.ReactNode;
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'children'>;

export function LinkButton({ tone = 'label', className = '', children, ...rest }: Props) {
    return (
        <button
            className={`text-ui font-semibold underline underline-offset-2 transition-opacity hover:opacity-70 disabled:opacity-50 ${TONES[tone]} ${className}`}
            {...rest}
        >
            {children}
        </button>
    );
}

export default LinkButton;
